"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var emotion_1 = require("emotion");
exports.inputButtonGroupWrapper = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n\n    & input {\n        width: 100%;\n        border-radius: 2px 0 0 2px;\n    }\n\n    & button {\n        border-radius: 0 2px 2px 0;\n    }\n"], ["\n    display: flex;\n\n    & input {\n        width: 100%;\n        border-radius: 2px 0 0 2px;\n    }\n\n    & button {\n        border-radius: 0 2px 2px 0;\n    }\n"])));
var templateObject_1;
